const carouselItems = [
  {
    title: '2026 国产悬疑剧巅峰盘点',
    desc: '《漫长的季节》《狂飙》《隐秘的角落》等高分悬疑剧全集一次看够。国产悬疑剧近年迎来了质量的飞跃，从剧本到表演都达到了新的高度。萝卜影视已收录全部高分悬疑剧完整版，豆瓣均分8.5+，每一部都值得反复品味。',
    tag: '专题推荐',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20Chinese%20urban%20landscape%20at%20twilight%20with%20fog%20rolling%20through%20narrow%20streets%2C%20warm%20street%20lamps%20casting%20long%20shadows%2C%20suspenseful%20cinematic%20atmosphere%2C%20film%20noir%20aesthetic%2C%20deep%20amber%20and%20dark%20tones%2C%20no%20text&width=1200&height=500&seq=carousel-luobo-01&orientation=landscape'
  },
  {
    title: '王家卫镜头美学：《繁花》全集解读',
    desc: '王家卫首部电视剧作品，全30集完整版在线观看。独特的镜头语言将90年代上海拍成了一首诗，胡歌、马伊琍、唐嫣等主演阵容豪华。萝卜影视已收录《繁花》全集高清版，带你沉浸式感受王家卫的光影世界。',
    tag: '导演专题',
    image: 'https://readdy.ai/api/search-image?query=Elegant%201990s%20Shanghai%20street%20with%20vintage%20signs%20and%20neon%20lights%2C%20golden%20hour%20sunlight%20streaming%20through%20old%20buildings%2C%20nostalgic%20romantic%20atmosphere%2C%20Wong%20Kar%20Wai%20inspired%20cinematography%2C%20warm%20amber%20tones%2C%20no%20text&width=1200&height=500&seq=carousel-luobo-02&orientation=landscape'
  },
  {
    title: '韩剧入坑指南：从经典到最新全集',
    desc: '从《黑暗荣耀》到《眼泪女王》，韩剧全集一网打尽。萝卜影视收录了超过420部韩剧完整版，覆盖爱情、复仇、奇幻、悬疑等热门题材。宋慧乔、金秀贤、金智媛等顶级演员的代表作全集均可在线观看。',
    tag: '韩剧合集',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Seoul%20cityscape%20at%20night%20with%20illuminated%20skyscrapers%20and%20traditional%20palace%20in%20foreground%2C%20warm%20city%20lights%20reflecting%20on%20Han%20River%2C%20romantic%20cinematic%20atmosphere%2C%20K-drama%20aesthetic%2C%20no%20text&width=1200&height=500&seq=carousel-luobo-03&orientation=landscape'
  },
  {
    title: '经典重温：那些年追过的神剧全集',
    desc: '《琅琊榜》《甄嬛传》《武林外传》等陪伴一代人成长的经典电视剧全集尽在萝卜影视。高清修复版画质让经典焕发新生，无论是重温还是补课，都能在这里找到最完整的电视剧全集资源，一次看够不留遗憾。',
    tag: '经典重温',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20with%20cherry%20blossoms%20in%20spring%2C%20traditional%20architecture%20with%20flowing%20silk%20curtains%2C%20soft%20golden%20sunset%20light%2C%20nostalgic%20classical%20Chinese%20aesthetic%2C%20elegant%20cinematic%20composition%2C%20no%20text&width=1200&height=500&seq=carousel-luobo-04&orientation=landscape'
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              专题推荐
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              精选电视剧全集专题合集，发现更多值得一看的好剧
            </p>
          </div>

          <div className="flex flex-col gap-6">
            {carouselItems.map((item, i) => (
              <div
                key={i}
                className="group relative overflow-hidden rounded-xl bg-background-100 border border-background-300/30 hover:border-primary-500/30 cursor-pointer transition-all duration-300"
              >
                <div className="flex flex-col md:flex-row">
                  <div className="md:w-[45%] lg:w-[40%] relative overflow-hidden">
                    <div className="aspect-[16/9] md:aspect-auto md:h-full min-h-[200px] md:min-h-[280px]">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-100 hidden md:block"></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-background-100 via-transparent to-transparent md:hidden"></div>
                  </div>

                  <div className="md:w-[55%] lg:w-[60%] p-5 md:p-8 flex flex-col justify-center">
                    <span className="inline-block px-3 py-1 rounded-full bg-accent-500/15 text-accent-400 text-xs font-medium mb-3 w-fit whitespace-nowrap">
                      {item.tag}
                    </span>
                    <h3 className="font-heading text-xl md:text-2xl text-foreground-50 mb-3">
                      {item.title}
                    </h3>
                    <p className="text-foreground-400 text-sm leading-relaxed">
                      {item.desc}
                    </p>
                    <div className="mt-5">
                      <a
                        href="#cards"
                        onClick={(e) => {
                          e.preventDefault();
                          document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                        }}
                        className="inline-flex items-center gap-2 text-primary-400 hover:text-primary-300 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
                      >
                        查看相关剧集
                        <i className="ri-arrow-right-line"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}